export default {
  zh: '简体中文',
  en: 'English',
  hello: 'Hello',
  title: 'Welcome to YiWu',
  login: 'Sign In',
  register: 'Register for free',
  user: 'User',
  logout: 'Sign Out',
  map: 'Map',

  // member: 'Member Center',
  memberCenter: 'Member Center',
  selfCenter: 'Member Center',
  myOrder: 'My Orders',
  reciveAddress: 'Addresses',
  collectShop: 'Favorite',
  messagNotification: 'Notifications',
  detail: 'Order detail',
  toLogin: 'Home',
  ExistAccount: 'Alredy have an account',
  check: 'Select',
  all: 'All',
  noData: 'No data',
  token: 'Please Re Login',
  error: 'Network error',
  nav: {
    allOrder: 'My Orders',
    toPay: 'Pending payment',
    send: 'Shipped',
    toCheck: 'To be received',
    success: 'Completed'
  },
  navigation: {
    personalAlive: 'Private Live',
    personalGoods: 'Special Products',
    demandGoods: 'Buying Needs',
    productType: 'Products',
    serveType: 'Markets',
    customerCenter: 'Customer Service',
    sellerEntry: 'Seller Entry',
    marketService: 'Market Services'
  },
  newJoin: {
    dataDoenload: 'Download',
    ranking: 'Ranking',
    floorLayout: 'Floor Layout',
    Keywords: 'Keywords',
    createAccount: 'Register',
    quickCreate: 'Create account',
    welcome: 'Hi , Welcome to Yiwu!',
    getNews: 'Notifications',
    privacy: 'I’ve read and agree to Chinagoods’ Privacy Policy.',
    privacy1: 'I’ve read and agree to ',
    privacy2: 'Chinagoods’Privacy Policy.',
    codeLogin: 'Sign in with password',
    yCodeLogin: 'Sign in with verification code',
    readAgree: 'Please read and agree the Privacy Policy',
    invationCode: 'Please enter the invitation code',
    quickJoin: 'Recruit Partners. Join Chinagoods'
  },
  personCnter: {
    noNeeds: 'No needs yet',
    noLive: 'No live yet',
    noProducts: 'No products yet',
    noAddress: 'No address yet',
    noCharts: 'No chats yet',
    noOrders: 'No orders yet',
    noQuestions: 'No questions yet',
    noInfo: 'No information',
    noStore: 'No stores yet',
    noGuests: 'No guests yet',
    noHotels: 'No hotels yet',
    rzfuwu: 'Financing',
    myNeeds: 'My Needs',
    smallMarket: 'Yiwu Markets'
  },
  market: {
    map: 'Map',
    introduce: 'Market Overview',
    notice: 'Notifications',
    path1: 'The No.1 Bus',
    path2: 'International Production Materials Market Shuttle Bus',
    time: 'Timetable',
    particulars: 'Market Overview',
    bazaar: 'Market Overview',
    home: 'Homepage',
    msg: 'Market Information',
    rank: 'Best Stores Rank',
    toshop: 'Learn more',
    attention: 'Add to List',
    score: 'Score',
    Scan: 'Scan to view',
    marketRank: 'Market Rank',
    buyPhone: 'Scan to buy',
    Nmarket: 'Market Number',
    homePage: 'Chinagoods.com–Yiwu Market Trade Service Platform',
    circuit1: 'Timetable',
    circuit2: `Int'l Production Materials Market Shuttle Bus`
  },
  intoYiwu: {
    walkInto: 'Yiwu',
    yiwuDescribe: 'A city of markets',
    welcome: 'Welcome to Yiwu!',
    yiwuInfomation:
      'President Xi Jinping has presented Yiwu to international communities multiple times, saying it’s the world “capital of small commodities”. Under the leadership of local government, CCC Group facilitates to providing visitors and customers from all over the world with all sorts of services from entry and exit, commerce and trade to local life. All is for you to feel easy to trade in Yiwu, and here  you can buy from the world and sell to the world.',
    seeMap: 'Check Map',
    scenic: '4A Scenic Spots',
    yiwuGuid: 'Foreigner Services',
    yiwuGuid1: 'Buyers Service',
    yiwuGuid2: 'Yiwu Fairs',
    yiwuGuid3: 'High-Tech Park',
    hotel: 'Hotel Reservation',
    content:
      'A one-stop platform to serve foreigners in government-related,commercial and trade matters by collaboration with Yiwu entry and exit administration(under preparation).',
    content1:
      'Offer merchants and foreign buyers policy information about markets, trade and local living, take on foreign services like company registration, work permit and residence permit.',
    content2:
      'China Yiwu International Commodities Fair, China Yiwu Hardware & Electrical Appliances Trade Fair, China Yiwu Imported Commodities Fair, China Yiwu Overseas Exhibition, China Yiwu International Forest Products Fair......Welcome friends from anywhere to join us at fairs.Start your journey to know more about Yiwu and trade more in Yiwu.',
    content3:
      'CCC Group’s six hotels provide you with top quality accommodation, catering and conference services at favorable prices.The best choice for your stay in Yiwu.',
    content4:
      'CCC Cross-Boarder (Import) Ecommerce Park, sitting at the core of the planned Yiwu Comprehensive Bonded Zone, is equipped with the office building, star class hotels, shopping mall, warehouse and parking.'
  },
  logisticsFinancial: {
    financialTitle: 'Credit & Finance',
    financialTitle2: 'Credit is the foundation of trade and finance',
    contentTille1: 'Credit Warning',
    contentTille2: 'Trade Insurance',
    contentTille3: 'Industry Chain Finance',
    content1:
      'Yiwu International Trade Services and Economic Case Warning Platform has been in place since 18 September 2009. It focuses on serving the markets which benefit from its large coverage and professionalism.',
    content2:
      'Partnering with China Export & Credit Insurance Corporation, CCC provides international trade companies with services like credit insurance, export financing, information consultation and receivables management, and help manage the foreign exchange risk for firms exploring the overseas market.',
    content3:
      'Data information from CCC group,yiwucredit.com and Economic Case Warning Platform are connected.In this way,  enterprise information of all these systems is associated. It can provide visitors with a full range of trade warning information.',
    content4:
      'Promote the construction of market credit system, and strengthen the integration of financial resources',
    viewAll: 'Learn more',
    enter: 'Learn more',
    company: 'China Export & Credit Insurance Corporation',
    logisticsTitle: 'Logistics',
    logisticsTitle1: 'Yiwu is the national logistics hub',
    listTitle: 'Yiwu Logistics Strengths ',
    listTitle1: 'Yiwu Comprehensive Bonded Zone',
    listTitle2: 'e-WTP Partnership',
    yxo: 'Yiwu - Xinjiang - Europe Train',
    listContent:
      'Yiwu, as one of the first 17 international inland cities nationwide, is China’s important logistics hub(Yiwu renowned for its trade and commerce service was selected into the first batch of national logistics hub construction list).',
    listContent0:
      'Domestic postal and express delivery totaled 4.884 billion pieces  in Yiwu in 2019. Yiwu ranked the second in terms of express delivery volume, only behind Guangzhou and ahead of Beijing, Shanghai and Shenzhou.',
    listContent1:
      'Yiwu Comprehensive Bonded Zone plays a positive role in the global trade chain. It highlights digitalization,tax preference, display and trade, and will make international trade much easier and freer. ',
    listContent2:
      'e-WTP, Alibaba’s electronic world trade platform, aims to facilitate the access to the global market    for the developing countries, small - and - medium enterprises and young people, who can better participate in the world economy.In June 2019, Yiwu and Alibaba signed the strategic cooperation agreement to jointly build the eWTP Global Innovation Center.',
    listContent3:
      'Yiwu-Xinjiang-Europe Train plan was initiated by President Xi Jinping in September 2014, running across Eurasia and linking the Pacific and Atlantic oceans. So far, there have been 12 international train lines opened, starting from Yiwu.',
    logisticsInfo: 'CCCL',
    logisticsInfo1: 'Global Yida',
    logisticsInfo2: 'Third-Party Logistics ',
    warehouse: 'Houzhai',
    warehouse1: 'Niansanli',
    warehouse2: 'International Trade Market Logistics Warehouse Park',
    despatchWay: 'LCL',
    despatchWay1: 'FCL',
    despatchWay2: 'Enquiry',
    logisticsWay: '短驳',
    logisticsWay1: '快递',
    logisticsWay2: 'Domestic logistics',
    thirdDescribe1:
      'Centering around the upstream and downstream business of markets, CCC develops the trade warehouse, micro-and-small startup park and micro-and-small logistics park to boost Yiwu’s service capacity of the distribution warehouse, regional warehouse and overseas warehouse. So all trade related parts can be covered and the “logistics warehouse +” formed.',
    thirdDescribe2:
      'Global Yida commits to building a highly standardized, digital and visual logistics information platform, integrating the fragmented logistics demand and empowering trade companies and trade agencies in Yiwu, so ultimately customers can receive highly convenient, efficient and low cost services for customs clearance and logistics.',
    thirdDescribe:
      'Various well-known suppliers are connected to chinagoods.com for the online and offline customers of Yiwu markets to enjoy high - quality domestic and overseas logistics services including drayage, express, sea and air freight.',
    marketTitle: 'Yiwu Markets',
    marketTitle1: "World'slargest small commodity wholesale market ",
    marketDescribe1:
      'Yiwu China Commodities City, sitting in Yiwu of Zhejiang since 1982, covers an area of over 6,400,000 m',
    marketDescribe2:
      ' with 75,000 booths, 210,000 staff and 210,000 daily visitors. It sells 2.1 million items from 26 commodity categories. The UN, World Bank and JP Morgan have named it the "largest small commodity wholesale market" in the world',
    square: '2',
    detailIntroduction: '详细介绍',
    joinMarket: 'Open your booth',
    squareMetre: 'Square Meters',
    shangwei: 'Booths',
    dalei: 'Categories',
    wan: 'W',
    shang: '75000',
    kind: '2.1M',
    typeBusiness: 'Products',
    seeDetails: 'More',
    bookHotel: 'Book Now',
    logCompany: 'Recruit  Logistics Partners!',
    area: '6.4M'
  },
  mapinfo: {
    nationTitle: 'Global Layout',
    nationTitle2: 'Follow national Going Global Strategy and leverage SOE strength',
    itinerary: 'Belt & Road Initiative',
    operating: 'In operation',
    preparation: 'In preparation',
    panama: 'Panama',
    ethiopia: 'Ethiopia',
    gibbdike: 'Djibouti',
    burma: 'Myanmar',
    Korea: 'South Korea',
    Spain: 'Spain',
    Germany: 'Germany',
    Czechia: 'Czechia',
    Rwanda: 'Rwanda',
    UnitedArabEmirates: 'United Arab Emirates',
    Yiwu: 'Yiwu, China',
    Japan: 'Japan',
    Operator: 'Operator',
    Office: 'Office',
    Showroom: 'Showroom',
    cChu: 'CCCL'
  },

  collect: {
    title: 'Favorite',
    market: 'Market',
    HY: 'HuangYuan',
    BW: 'BinWang',
    FH: 'Bonded Area',
    openTime: 'Business hours',
    tel: 'Contact Number',
    viewCode: 'Scan and view',
    viewShop: 'View store'
  },
  order: {
    searchTit: 'Order ID or Product Name',
    search: 'Search',
    orderStatus: 'Order status',
    toPay: 'Pending payment',
    send: 'Shipped',
    success: 'Completed',
    toCheck: 'To be confirmed',
    cancel: 'Cancel',
    toSend: 'Shipping on behalf of',
    refundCheck: 'Refund pending',
    refundCancel: 'Cancel the refund',
    refundConfirm: 'Merchant has agreed to a refund',
    refundRefuse: 'Merchant refuses refund',
    refundSuccess: 'Refund successfully',
    orderNum: 'Order ID',
    creatTime: 'Order time',
    includeFare: 'Shipping included',
    toRecept: 'Confirm receipt',
    toEvaluate: 'Review orders',
    orderDeatil: 'Order detail',
    cacelOrder: 'Cancel the order',
    receptConfirm: 'Whether to confirm receipt',
    receptSuc: 'Confirm the receipt is successful',
    cancalRecpt: 'Canceled receipt',
    calcelTit: 'The order cannot be restored after cancellation. confirm the cancellation?',
    cancelSuc: 'Canceled successfully ',
    cancelOprate: 'Canceled',
    rateTit: 'Select the ratings',
    evaluateSuc: 'Comment successful'
  },
  addr: {
    username: 'Contact Name',
    nameRule: 'Contact Name',
    IDnumber: 'ID Number',
    IDnumRule: 'ID Number',
    receiveName: 'Name',
    receiveNameRule: 'Name',
    telephone: 'Mobile Phone Number',
    pheRule: 'Mobile Phone Number',
    area: 'Region',
    areaRule: 'Region',
    detailAddress: 'Detail address',
    detailAddrRule: 'Detail address',
    save: 'Save',
    editAddr: 'Change address'
  },
  orderDeatil: {
    addrNow: 'Current position',
    detail: 'Order detail',
    orderNum: 'Order ID',
    shop: 'Purchase merchant',
    createdAt: 'Order time',
    payTime: 'Payment time',
    receiveUser: 'Receiver',
    shipper: 'consignee',
    payType: 'Payment method',
    payID: 'Buyer ID',
    statu: 'Order status',
    logisticType: 'Shipping methods',
    addr: 'Shipping address',
    phone: 'Contact details',
    wareAddr: 'Warehouse address',
    shopMoney: 'Price',
    fare: 'Shipping fees',
    weight: 'Weight',
    taxrate: 'Import tax',
    discount: 'Merchant discount',
    total: 'Total',
    viewLogistic: 'Track package',
    logistic: 'Express',
    logisticNews: 'No delivery status',
    shopName: 'Product name',
    num: 'Quantity',
    price: 'Price',
    money: 'Amount',
    wxpay: 'WeChat',
    cash: 'Cash',
    alipay: 'AliPay',
    cardpay: 'Credit Card ',
    warehouse: 'Pick up from warehouse',
    sendGoods: 'Express',
    selfTake: 'Self pick up',
    productAll: 'All product'
  },
  rate: {
    title: 'Write a customer review',
    myTitle: 'My reviews',
    allRate: 'Review',
    noRate: 'Please writer a product review~~',
    shopReply: 'Replied',
    textTit: 'Review this transaction～',
    publish: 'Submit',
    cancel: 'Cancel'
  },
  phone: {
    title: 'Mobile Phone',
    placeholderPhone: 'Please Enter the Mobile Phone Number',
    placeholderVerify: 'One time password',
    noLogin: 'No relogin required within 7 days',
    submit: 'Sign in',
    goRegister: 'Register',
    getCode: 'Get OTP',
    code: 'OTP'
  },
  logon: {
    area: 'Country/Region',
    areaRule: 'Country/Region',
    open: 'Open',
    close: 'Pack up',
    telephone: 'Mobile Phone Number',
    placeholderTelephone: 'Mobile Phone Number',
    code: 'OTP',
    placeholderCode: 'One time paeeword',
    username: 'Name',
    placeholderUsername: 'Username',
    password: 'Password',
    placeholderPassword: 'Password',
    Invitation: 'Invitation Number',
    placeholderInvitation: 'Invitation Number',
    idWord: 'ID Number',
    placeholderIdword: 'Number',
    address: 'Shipping Address',
    placeholderAddress: 'Province/City/District',
    detailAddress: 'Detail Address',
    placeholderDetailAddress: 'Detail Address',
    surname: 'Surname',
    placeholderSurname: 'Please Input',
    name: 'First Name',
    company: 'Company',
    placeholderCompany: 'Company Name',
    job: 'Job Title',
    placeholderJob: 'Title',
    register: 'Register Immediately',
    tips: 'If you buy bonded goods, you need to provide real-name documents',
    idCard: 'ID Card No',
    passPort: 'Passport Number',
    closeTit: 'Confirm close',
    nameRule: 'At least 4 to 16 characters',
    passRule: '6 characters or more',
    account: "By creating an account, you agree to Our's Conditions of Use and Privacy Notice.",
    commodity: "China's Commodity City Privacy Notice "
  },
  application: {
    slgon: 'The Application Form of Travel and Accommodation Allowance',
    yourName: '2.Name',
    placeholderSurname: 'Surname',
    placeholderName: 'Given name',
    yourSex: '3.Gender',
    male: 'Male ',
    female: 'Female',
    sexRule: 'Gender',
    nameRule: 'Given name',
    surnameRule: 'Surname',
    yourBirthday: '4.Date of birth',
    birthdayRule: 'Please select Date of birth',
    birthdayArrivalDate: 'Please select Estimated time of arrival in Yiwu',
    passportCountry: '5.Country issuing the passport',
    pleaseChoose: 'Please select',
    passportNumber: '6.Passport Number',
    passportCountryRule: 'Country issuing the passport',
    pleaseInput: 'Please fill in',
    contactWays: '7.Contact Number',
    domesticTel: 'China Mobile',
    overseasTel: 'Foreign Mobile',
    overseasTelInput: 'Mobile used outside China.',
    domesticTelInput: 'Mobile used in China.',
    email: 'Email Address',
    placeholderTel: ' Could fill in yourself or your contact person inside China.',
    domesticTelCue:
      'Note: Either your own mobile number in China or the mobile of your contact in China',
    flightInfo: '8.Tentative Flight Info',
    airlineCompany: 'Name of airline',
    flightNumber: 'Flight No.',
    departureDate: 'Date of departure',
    arrivalDate: '9.Estimated time of arrival in Yiwu',
    time: 'Please select time',
    explain: 'Note: ',
    type2list1: 'Your flight expense（the economy class）will be half subsidied.',
    type2list2: 'Three days of free accommodation will be provided by CCC Group.',
    type2list3: 'The ticket fare of departure from Yiwu is excluded from subsidy。',
    type3:
      'Note: The ticket fare of economy class will be fully subsidized by us if you arrive in Yiwu before February 29 and make valid procurement of USD 50,000 or above within 15 working days after arrival. The ticket fare of economy class will be half subsidized by us if you arrive in Yiwu from March 1 to March 10 and make valid procurement of USD 50,000 or above within 15 working days after arrival.',
    address: '10.Address in Yiwu',
    street: 'Street / Town',
    detailAddress: 'Detailed Address：',
    freeAccommodation: 'Free Accommodation needed',
    homeAddress: 'Having residence in Yiwu ',
    hotelTime: 'Hotel Check-in and out Dates: ',
    startTime: 'Check-in Date',
    endTime: 'Check-out Date',
    adslist1:
      'Maximum of 7-day free accommodation will be provided if you arrive in Yiwu before February 29',
    adslist2:
      'maximum of 3-day free accommodation will be provided if you arrive in Yiwu between March 1-10.',
    adslist3: 'The hotel will be designated by CCC Group.',
    adslist4:
      'Note: 3-day free accommodation will be provided if you arrive before March 10. The hotel is to be designated by CCC Group.',
    cashExplain: 'Terms on ticket subsidy: ',
    explainTxt:
      'you will be reimbursed in cash after you present the ticket voucher to the hotel at check-out. CCC Group is responsible for explaining details.',
    purchaserType: '1.Types of Buyers',
    purchaserType1:
      'Type ①: Foreign buyers who are the shareholders or legal representatives of commercial and trade companies registered in Yiwu.',
    purchaserType2:
      'Type ②: Foreign buyers who have previous Yiwu entry and exit and procurement records.',
    purchaserType3: 'Type ③: Foreign buyers with no entry & exit or procurement records in Yiwu.',
    purchaserType4:
      'Type ④: Chinese buyers who are shareholders or legal representatives of commercial overseas companies live in a foreign country or have a permanent resident card and Yiwu entry record.',
    accessRecords: 'Record of staying in Yiwu：',
    purchaseRecord: 'Purchase Record: ',
    cue1: 'Note: Please provide relevant documents (pictures or PDF files)',
    cue2:
      'Record of staying in Yiwu: please provide one of the following items( Yiwu Entry&Exit record, or Biz-buddy Card record or Yiwu hotel check-in information before January 1, 2020)',
    cue3:
      'Purchase Record: transaction documents with trading companies or shop-owners in Yiwu by January 1st , 2020',
    enclosure: 'Attachments：',
    enclosure1: 'Residence Permit for Foreigner：',
    enclosure2: 'Business Licence：',
    cue4:
      'Note: For commercial enterprises registered in Yiwu, please upload the photo or scanned copy of business license',
    cue5:
      'Note :Please provide basic information of Yiwu trading companies or shop-owners (scanning copy of business license or industrial and commercial certificate with official seal), supporting pictures and PDF documents',
    cue7: '(1) Please scan your residence permit issued by the government.',
    cue8:
      '(2) Please upload your business license of commerce company or shareholder certificate issued by overseas countries.',
    cue9:
      '(3) Please upload your Yiwu entry record, flight ticket or Yiwu hotel check-in record before January 1st, 2020.',
    cue0:
      '(4) Please upload your remittance or payment voucher of USD 50,000 or above with Yiwu company before January 1st, 2020.',
    agree: "I'm aware of and accept",
    agreement: "《Subsidy policy measures for Foreign Buyers' procurements in Yiwu.》",
    companyContant: ' 11.Contact manner of the Initiating invitation unit inside Yiwu',
    companyName: 'Unit Name',
    companyPerson: 'Contact person',
    companyTel: 'Cell number',
    sendEmailCue: 'You can send email if you fail to submit it on the page',
    emailAds: 'freetoyiwu@chinagoods.com',
    passportNumberRule: 'Passport Number',
    emptyRule: 'Content cannot be empty',
    endtimeRule: 'Please choose the end time',
    submit: 'Submit',
    company: 'Zhejiang China commodities City Group Co.,Ltd',
    title: "Subsidy policy measures for Foreign Buyers' procurements in Yiwu.",
    explains:
      'The initiating invitation unit should timely inform foreign buyers invited, as requested by our subsidy policy, to get subsidy they should provide evidence of: Procurement records (purchasing contract + Remittance voucher) of USD 50,000 or above; Must be non RMB foreign exchange collection; The payee must be an enterprise registered in Yiwu.',
    tips:
      'If you pass the subsidy condition review, and your country has direct flights to Yiwu, we will provide one-way ticket subsidy (economy class); if your country has no direct flights to Yiwu, we will provide one-way ticket subsidy (economy class) for no more than one transfer.',
    month: 'February 19, 2020',
    illustration: 'Illustration',
    Directflight: 'Direct flight',
    oneTransit: 'One-transfer flight',
    Transit: 'Transfer flight',
    Application: 'Application Form of Subsidy for Travel and',
    word: 'Accommodation in Yiwu for Foreign Buyers',
    noFree:
      'No free accommodation will be provided if you arrive in Yiwu after March 10.The hotel will be designated by CCC Group.'
  },
  welecomeToYiWu: {
    toDeclare: 'Learn more',
    toApply: 'Learn more',
    toHotel: '去预定',
    hotel: '酒店预订',
    currentPosition: 'Current location',
    convention: 'Fair Exhibitor Application',
    name: 'Name',
    Gender: 'Gender',
    man: 'M',
    women: 'F',
    idType: 'ID type',
    idNumber: 'ID number',
    Nationality: 'Nationality',
    Province: 'Province',
    city: 'City',
    companyAddress: 'Company address',
    companyName: 'Company name',
    jobTitle: 'Job title',
    Department: 'Department',
    Contacts: 'Contacts',
    email: 'Email',
    interest: 'Categories are of interest to you (multi options)',
    companyBusiness: "Your company's nature of business(multi options)",
    others: 'Other(please indicate)',
    attend: 'Your purpose of attending fair(multi options)',
    wayConcatType: 'In what way you wish the executive committee contact you(multiple choice)',
    submit: 'Submit',
    purchaser: "Buyer's Health Report",
    declareChoose: 'Declaration of option',
    placeLocation: 'Place of domicile',
    foreignCard: 'Do you have Foreign Citizen Card',
    yes: 'Yes',
    no: 'No',
    currentYiWuAddress: 'Current residence in Yiwu',
    currentHealthy: 'How about your current physical condition',
    Fever: 'Fever',
    Cough: 'Cough',
    Ingoodhealth: 'In good health',
    daysOut: 'Your travels for previous 14 days',
    type1: '1.Hubei, Wenzhou, Taizhou ',
    type2: '2.Contacted with confirmed cases or gathered with them',
    type3: '3.Do you have historical epidemiology or any similar symptom',
    familyMembers: 'Have you or your family members contacted with such patients',
    commitmentChecked:
      'I promise that the above information is true,if false, willing to bear corresponding legal responsibility',
    entry: 'Entry Permit for Foreigners',
    type: 'Type',
    phone: 'Phone',
    chineseName: 'Chinese name',
    dateOfBirth: 'Date of birth',
    placeOfBirth: 'Place of birth',
    passportType: 'Passport Type',
    passportNumber: 'Passport No.',
    IssueDate: 'Date of issue',
    validityOfPassport: 'Date of expiry',
    entryTime: 'Entry time',
    validityOfVisa: 'Validity of visa',
    visaNumber: 'Visa No.',
    visaType: 'Visa type',
    word1: {
      pleaseEnter: 'please enter',
      placeSelect: 'please select ',
      pleaseName: 'Enter full Name',
      pleaseSex: 'Select sex',
      pleaseIdType: 'Select ID type',
      pleaseIdNumber: 'Enter ID number',
      pleaseLegalIdNumber: 'Enter Identity number',
      pleaseCountry: 'Select nationality',
      pleaseArea: 'Select region',
      pleaseDetailAddress: 'Enter details',
      pleaseCompanyName: 'Enter company name',
      pleaseDepartment: 'Enter department',
      pleasePosition: 'Enter job title',
      pleaseContant: 'Enter contacts',
      pleaseLegal: 'Enter mobile number ',
      pleaseEmail: 'Enter email',
      pleaseInterested: 'Categories are of interest to you',
      pleaseBussiness: "Check the your company's nature of business",
      pleaseAttendPurpose: 'Check the your purpose of attending fair',
      pleaseWitchConcatType: 'Check the way you wish the executive committee contact you',
      pleaseWitchConcatNumber: 'Enter the way you wish the executive committee contact you',
      placeType: 'Select type',
      placeChineseName: 'Enter chinese name',
      dateOfBirth: 'Select date of birth',
      placeOfBirth: 'Enter place of birth',
      placePassportType: 'Select passport Type',
      placePassportNumber: 'Enter passport number',
      placeIssueDate: 'Select date of issue',
      placeValidityOfPassport: 'Select date of expiry',
      placeEntryTime: 'Select entry time',
      placeValidityOfVisa: 'Enter validity of visa',
      placeVisaNumber: 'Enter visa No.',
      placeVisaType: 'Enter visa type',
      placeDeclare: 'Enter declaration of option',
      placeDomicileLocation: 'Eneter place of domicile',
      placeFriendsBusinessCard: 'Select foreign Citizen Card',
      placeCurrentAddress: 'Eneter current residence in Yiwu',
      placeCurrentHealth: 'Check the how about your current physical condition',
      placeDaysOut: 'Check the your travels for previous 14 days',
      placeFamilyMembers: 'Select you or your family members contacted with such patients'
    },
    declareType1: 'Domestic buyers from areas less affected by the epidemic (Class A)',
    declareType2:
      'Domestic buyers from areas severely affected by the epidemic including Hubei, Taizhou and Wenzhou (Class B)',
    declareType3: 'Resident foreign buyers in Yiwu (Class C)',
    declareType4: 'Non-resident foreign buyers in Yiwu (Class D)',
    idcardType1: 'ID Card',
    idcardType2: 'Passport',
    idcardType3: 'Mainland Travel Permit for Macao Residents',
    idcardType4: 'Mainland Travel Permit for Taiwan Residents',
    idcardType5: 'Mainland Travel Permit for Hong Kong',
    concatType1: 'Email',
    concatType2: 'Wechat',
    concatType3: 'Phone',
    concatType4: 'QQ',
    visaType1: 'visa',
    visaType2: 'Foreigner Work Permit',
    visaType3: 'New company setup in Yiwu',
    passportType1: 'Diplomatic Passport',
    passportType2: 'Official Passport',
    passportType3: 'Regular Passport',
    passportType4: 'Others'
  },
  publicText: {
    location: 'Current location',
    noData: 'No data available',
    searchTips: 'Search for product keywords',
    searchTipsTwo: 'Name of store/Mobile number ',
    clickUpload: 'Upload',
    chosen: 'items ticked',
    list: 'Lists',
    map: 'maps',
    sales: 'sales',
    sold: 'sold',
    Fcollect: '❤',
    haveCollect: 'Favourite',
    SalesRevenue: 'Sales Revenue',
    price: 'Price',
    favorite: 'Add to List',
    toBeCollected: 'Add to List',
    collected: 'Liked',
    commodity: 'Products',
    commodity2: '',
    shop: 'Best Stores',
    watch: 'Viewers',
    hello: 'Hi',
    welcome: 'Welcome to Yiwu!',
    user: '用户',
    clickwhatIsProcurement: 'What is Omni-scenario Purchasing?',
    whatIsProcurement: 'Omni-scenario Purchasing',
    procurement:
      "Purchasing can happen in different environments. It might be at brick-and-mortar stores, where you pay by cards, scanning QR code, or bank transfer if you're the regular customer and buy a lot. It can also be done online. You place order with Wechat communication or buy directly while watching Live Stream.",
    QA: 'FAQ',
    grabbed: 'sold',
    endOfDistance: 'Ends in',
    pieces: 'items',
    productDetails: 'Product details',
    ranking: 'rank',
    storeRanking: 'Similar Stores Rank',
    productsRecommended: 'Similar Items',
    recommendedForYou: 'Recommendations for you',
    sorry: 'Sorry, no results for ',
    relatedProducts: '',
    allMarkets: 'All Markets',
    explosion: 'Hot ',
    found: 'Search for',
    relatedShops: 'Similar Stores',
    home: 'stores',
    mapMode: 'Maps',
    listMode: 'Lists',
    uploadAttachment: 'Attachment',
    rate: 'Ratings',
    post: 'Continue',
    vipPrice: 'Member price',
    desc: 'Descriptions',
    sameProducts: 'Similar items',
    tips:
      'You can only have contract transaction and offline payment with one store at a time.Individual/ enterprise real-name authentication required. ',
    noGoods: 'No products yet',
    day: 'days,',
    hour: ':',
    minute: ':',
    second: '',
    hotGoods: 'Hot',
    issudeTime: 'Date added',
    haveVideo: 'Live Video',
    haveNotFand: 'No such item? Try to release your buying needs.',
    publishSearch: 'Want to buy',
    searchGoods: 'Item name',
    Lpic: 'Pictures',
    productDetail: 'Descriptions',
    quickSearch: 'Release',
    shopInSearch: 'Search in this store',
    keyCode: 'Keywords',
    businessLice: 'Business License',
    verified: 'Verified',
    noVerified: 'Unconfirmed',
    view: 'View',
    rating: 'Credit Rating',
    inShop: 'Learn more',
    addList: 'Add to list',
    cancelList: 'Cancel list',
    shopZ: 'Certification',
    brand: 'Brand',
    brandId: 'Item Code',
    weight: 'Weight',
    name: 'Product Name',
    proType: 'Categories',
    size: 'Specification',
    source: 'Source',
    proInfo: 'Product Information',
    proDes: 'Descriptions',
    proPic: 'Picture',
    saleTop: 'Sales',
    collectTop: 'Favorites'
  },
  navbar: {
    login: 'Sign in',
    logOut: 'Sign Out',
    register: 'Create account',
    cart: 'Cart',
    member: 'Memberships',
    appDownload: 'APP Download',
    seller: 'Sellers App',
    buyer: 'Buyers App',
    sellerTitle: 'Sellers App',
    buyerTitle: 'Buyers App',
    ios: 'iOS下载',
    android: 'Android下载',
    cooperation: 'Seller/Partner Sign-in',
    download: 'Scan to download App',
    Cyber: 'Cyber Culture',
    Member: 'Membership application'
  },
  member: {
    status: {
      contract: 'View Contract',
      pay: 'Checkout'
    },
    order: {
      all: 'All',
      selfCenter: 'My Center',
      allOrder: 'All',
      detail: 'Details',
      wareAddr: 'Warehouse address',
      shipper: 'Consignee',
      title: 'My Orders',
      orderDate: 'Order time',
      cacelDate: 'Cancelled',
      paymentDate: 'Paid time',
      returnDate: 'Return time',
      revokeReturn: 'Cancel',
      orderInfo: 'Details',
      orderNumber: 'Order ID',
      business: 'Store',
      paymentType: 'Payment method',
      wxpay: 'WeChat payment',
      cash: 'Cash payment',
      alipay: 'Alipay',
      cardpay: 'Pay by credit card',
      orderStatus: 'Order status',
      address: 'My Address',
      logistics1: 'Track delivery',
      logistics2: 'Delivery method',
      payTheBalance: 'Pay Balance',
      cancelOrder: 'Cancel',
      applyReturn: 'Submit',
      refundCancel: 'Cancel refund',
      refundCheck: 'The refund to be confirmed',
      returnOut: 'Complete returns',
      refunding1: 'Refunding',
      refunding2: 'Returning',
      delayedReceipt: 'confirm Receipt',
      confirmReceipt: 'Confirm Receipt',
      toEvaluate: 'Write Reviews ',
      postAReview: 'Write Reviews',
      overview: 'Ratings',
      myComment: 'My Reviews',
      cancelReturns: 'Cancel returns',
      returnsDetail1: 'Details of refund',
      returnsDetail2: 'Learn more',
      merchantReply: "Seller's reply",
      viewLogistics: 'Track Delivery',
      pendingPayment: 'Unpaid',
      orderCancelled: 'Canceled ',
      toBeDelivered: 'To be Shipped',
      to_pay: 'To be paid',
      shipped: 'Shipped',
      comment: 'Write Reviews',
      completed: 'Completed',
      refund: 'Refunding',
      toCheck: 'To be confirmed',
      cancel: 'Canceled ',
      refundConfirm: 'Store has agreed to the refund',
      refundSuccess: 'Reimbursed',
      refundDown: 'Refund closed',
      warehouse: 'Pick up goods by yourself',
      sendGoods: 'Express',
      selfTake: 'Pick up goods on site',
      logisticNews: 'No logistics information ',
      commentTips: "Are you satisfied with the transaction? We'd like to hear your voice~",
      returnTips1: 'Return request is submitted successfully, please be patient.',
      returnTips2: 'The supplier accepts return and refunds',
      returnTips3:
        'After receiving returned goods, refund will be transmitted to the original payment account.',
      orderSearchTips: 'Enter product No. or product name',
      emptyEvaluationTips: 'No reviews from you yet.',
      deletePrompt: 'The order cannot be restored after cancellation, still cancel?',
      returnPrompt: 'You cannot apply to return the item again if you cancel, still cancel?',
      calcelTit: 'Cancel?',
      calcelTits: 'The order cannot be restored after cancellation, still cancel?',
      cancelSuc: 'Order was cancelled successfully',
      cancelOprate: 'Cancel operation',
      to_send: 'To be Shipped',
      to_sign: 'To sign',
      toPayDeposit: 'Make Down Payment',
      toPayFinal: 'Pay Balance',
      toReceive: 'To be signed for',
      invalid: 'Invalid',
      toStockUp: 'In stock',
      close: 'close',
      evaluateSuc: 'Reviewed',
      receptSuc: 'Confirm Receipt',
      rateTit: 'Please select star rating',
      changeTelephone: 'Change mobile number ',
      payStatus: 'Payment Status'
    },
    privacy: {
      title: 'Special goods & Live'
    },
    favorite: {
      title: 'My Lists',
      shop: 'Stores',
      commodity: 'Products',
      category: 'Categories',
      allMarkets: 'All Markets',
      title2: 'Favourite stores',
      market: 'Market',
      HY: '篁园',
      BW: '宾王',
      FH: '孵化区',
      viewCode: 'Scan code to view'
    },
    address: {
      title: 'My Address',
      subTitle: 'Shipping Address Settings',
      receiver: 'Recipient',
      phone: 'Mobile number',
      operating: 'Deletion',
      addAddress: 'Add another address',
      changeAddress: "Change recipient's address",
      setAsDefault: 'Set default',
      defaultAddress: 'Default',
      name: 'Recipient name',
      citizenship: 'Nationality',
      area: 'Region',
      address1: 'Address',
      address2: 'Details',
      deletePrompt: 'Deletion is unrecoverable, still delete?'
    },
    myInfo: {
      title: 'Account',
      telephone: 'Mobile number',
      password: 'Password',
      email: 'Email',
      unbounded: 'Unbound',
      changeTelephone: 'Change or Add mobile phone',
      changeEmail: 'Change or Add email',
      changePassword: 'Change or Add password',
      changeDetail: 'Information Change',
      word1: {
        title: 'Change mobile phone',
        code: 'verification code',
        codeError: 'verification code error',
        getCode: 'Send',
        changePassword: 'Change password',
        newPassword: 'New password',
        changeEmail: 'Change email',
        email: 'Email',
        pleaseCode: 'Please enter verification code',
        pleaseEmail: 'Please enter email',
        pleaseNewpassword: 'Please enter new password',
        pleasePassword: 'Please enter password'
      },
      authentication: 'real-name authentication'
    },
    news: {
      title: 'Notifications',
      titleContent: 'Message content',
      date: 'Date',
      operating: 'Deletion',
      tips: 'Mark as read',
      open: 'More',
      packup: 'Hide'
    },
    work: {
      title: 'My Questions',
      allWork: 'All',
      processing: 'Processing',
      processed: 'Processed',
      addWork: 'Add new questions',
      number: 'Sequence',
      workNumber: 'Question number',
      problemDescription: 'Descriptions',
      updateDate: 'Update',
      addDate: 'Submit',
      type1: 'Types',
      type2: 'Questions Types',
      status: 'Status ',
      operating: 'Deletion',
      sendAnnex: 'Attachment',
      recording: 'Records',
      reply: 'Reply',
      surname: 'Surname',
      name: 'First Name',
      phone: 'Mobile number',
      email: 'Email',
      viewWork: 'Details',
      sendSuccess: 'Success',
      submitSuccess: 'Questions submitted successfully.',
      uploadTips: 'Upload image or pdf file under 2MB,  no more than 9 files.',
      submitSuccessMessage: "Please be patient, it's under processing~",
      details: 'Details',
      viewWorks: 'View My Questions'
    },
    fastPayment: {
      title: 'My bank card',
      addBankCard: 'Add bank card',
      add: 'bank card added',
      add2: 'bank cards added',
      noCards: 'No cards yet',
      cardsNumber: ''
    },
    returns: {
      returnDetail: 'Learn more',
      returnsTips1: 'Please select returned goods and confirm quantity',
      returnsTips2: 'Fill Out Return Form',
      reason: 'Reasons',
      reasonMessage: 'Select the reason',
      description: 'Descriptions',
      descriptionMessage: 'Describe details',
      number: 'Returned items',
      amount: 'Refund',
      return: 'Submit',
      cancel: 'Cancel',
      returnDate: 'Refund time',
      uploadTips:
        'To better meet your needs, please upload image under 5MB each, no more than 9 ones in total.',
      orderNote: 'Notes',
      leaveMessage: 'Notes'
    },
    account: {
      title: 'Forex Account',
      addAccount: 'Add forex account',
      accountManage: 'Forex account management',
      changeAccount: 'Change forex account',
      person: 'Payer',
      accountNumber: "Payer's account",
      setAccountNumber: 'Default',
      payAccountNumber: "Payer's account"
    },
    financial: {
      title: 'Finance Service'
    },
    logOff: {
      title: 'Cancel the Account',
      Notice: 'Notice for Cancellation',
      noticeTitle:
        'Before submitting the cancellation application, please carefully confirm the following instructions:',
      notice1:
        '1. After the account is cancelled, the various coupons, order information and other platform information in the account will be cleared;',
      notice2:
        '2. If there is a suspicious order in the account, please complete the order processing first. Then proceed to cancel the account.',
      hasRead: 'I Have Read',
      smsVerification: 'SMS Verification',
      smsNotice1: 'The system has sent a verification message to your mobile phone number',
      smsNotice2:
        'please fill in the verification code you received into the input box below and submit for verification',
      smsErrorNotice1:
        'SMS verification failed, please obtain the verification code again! The system will resend a new verification message to your mobile number',
      smsErrorNotice2:
        ' please fill in the verification code you received in the input box below and submit it for verification',
      emailVerification: 'Email Verification',
      emailNotice1: 'The system has sent a verification message to your Email',
      emailNotice2:
        'please fill in the verification code you received into the input box below and submit for verification',
      emailErrorVerification: 'Email verification failed',
      emailErrorNotice1:
        'Email verification failed, please obtain the verification code again! The system will resend a new verification message to your your Email',
      emailErrorNotice2:
        'please fill in the verification code you received in the input box below and submit it for verification',
      iDAuthentication: 'ID Authentication',
      IdDear: 'Dear Mr./Ms. ',
      idNotice1:
        'you are in the process of canceling your Chinagoods account. Please enter the last six digits of your ID card below and submit for verification',
      idErrorNotice1:
        'the last six digits of your ID card do not match the system information. Please re-enter the last six digits of your ID card below and submit for verification',
      cancel: 'Cancel',
      submit: 'Confirm',
      logOffSucc: 'Successfully Cancelled',
      successNotice1:
        'thank you for using Chinagoods platform and looking forward to see you again!',
      complete: 'Complete',
      doNow: 'Do it Now',
      notice: 'Reminder',
      errorNotice1:
        'The current account has the following problems, please cancel the account after handling'
    },
    purchase: {
      title: 'Buying Needs',
      tList: 'Buying Needs List',
      publishNeed: 'Publish your needs',
      noNeed: '暂无需求',
      purProduct: 'Purchase products ',
      Description: 'Description ',
      pic: 'Picture',
      Quantity: 'Quantity',
      price: 'Estimate unit prices（CNY）',
      note: 'Note',
      basicInfo: 'Basic Information',
      proType: 'Types',
      allpro: 'All',
      allpro1: 'Selected Stores',
      allpro2: 'Categories',
      allpro3: 'Deadline',
      allpro4: 'Delivery date',
      allpro5: 'Description',
      selectShop: 'Select Store',
      shopName: 'Name of store',
      category: 'Select the category(max.3)'
    },
    hotel: {
      title: 'Hotel Order',
      allOrder: 'All',
      pendingPayment: 'To be paid',
      paid: 'Paid',
      confirmed: 'Confirmed',
      userCancel: 'Canceled',
      systemCancel: '系统取消',
      backgroundCancel: 'Canceled by hotel',
      refund: 'Refunded',
      hotelSearch: 'Search by hotel name'
    },
    logistics: {
      purchase: 'Logistic Demand',
      order: 'Logistics Order',
      PurchaseOrder: 'Purchase Order',
      Orderid: 'Order ID',
      type: 'Type',
      Status: 'Status',
      Deadline: 'Deadline',
      Quoted: 'Quoted',
      all: 'All',
      paid: 'To be paid',
      Shipped: 'To be Shipped',
      received: 'To be received',
      Canceled: 'Canceled',
      WriteReviews: 'Write Reviews',
      completed: 'Completed',
      Method: 'Procurement Method',
      Directpurchase: 'Direct purchase',
      InquiryPurchase: 'Inquiry Purchase',
      ServiceProvider: 'Service Provider'
    }
  },
  category: {
    all: 'Categories',
    hotRanking: 'Best Sellers Rank',
    shopRanKing: 'Best Stores Rank',
    explosion: 'Seasonal Hot',
    live: 'Live Stream',
    notice: 'Notifications',
    marketIntroduction: 'Market Overview',
    deatilDesc: 'Detailed content'
  },

  btn: {
    search: 'Search',
    searchAll: 'Search All',
    searchShop: 'Search Store ',
    more: 'Learn more',
    addCart: 'Add to Cart',
    buy: 'Buy Now',
    moreOptions: 'More options',
    putAway: 'Hide',
    determine: 'Continue',
    cancel: 'Cancel',
    multipleChoice: 'multi options',
    send: 'Continue',
    delete: 'Delete',
    selectAll: 'All',
    modify: 'Change',
    submit: 'Continue',
    time: 'Timetable'
  },
  live: {
    live1: 'Live',
    live2: 'Now',
    replay: 'Replay',
    treasurerLive2: 'Live Now',
    wonderfulPlayback: 'Replay',
    toChatWith: 'Talk to the anchor?',
    switchLive: 'To Live',
    isLiving: 'Live Stream Now',
    comeandWatch: 'Look, Look!',
    have: 'have',
    newInfo: 'new messages',
    tryAgain: 'Transcoding, please try later.',
    relateGoods: 'Similar Items',
    noPower: "Private live stream, you're not invited yet.",
    interaction: 'Speak out. Interact with hosts.',
    attention: 'Favorite'
  },
  menus: {
    describe: 'Full-service digital platform',
    home: 'Homepage',
    purchase: 'Omni-scenario Purchasing',
    welcomeToYiwu: 'Welcome to Yiwu',
    logistics: 'Logistics Hub',
    financial: 'Credit & Finance',
    customerService: 'Customer Service',
    market: 'Physical Market',
    international: 'Global Layout'
  },
  logisticsSide: {
    title: 'Shipping Application',
    logan: 'Please apply for shipping after login.',
    sender: 'Sender',
    senderInfo: 'Sender Information',
    recipient: 'Recipient',
    recipientInfo: 'Recipient Information',
    name: 'Full Name',
    placeholder: 'please enter',
    placeholderSelect: 'Select',
    company: 'Company',
    telephone: 'Mobile number',
    fixedTelephone: 'Fixed phone',
    country: 'Nationality',
    area: 'Region',
    detailAddress: 'Details',
    checkedItems: 'Shipment',
    checkedName: 'Shipment Name',
    cloume: 'Length x Width x Height(cm)',
    weight: 'Weight(kg)',
    delete: 'Delete',
    addChecked: 'Add Goods',
    othersInfo: 'Other Information',
    startTime: 'Expected shipping date',
    endTime: 'Expected receipt date',
    desc: 'Descriptions',
    success: 'Submitted successfully',
    info: "Please be patient, it's under processing~",
    newWord: 'New application form',
    submit: 'Continue',
    pleaseName: 'Enter username',
    pleaseTelephone: 'Enter phone',
    pleaseLegal: 'Enter legal phone',
    pleaseCountry: 'Select Nationality',
    pleaseArea: 'Select Region',
    pleaseDetailAddress: 'Enter Details',
    pleaseCheckedItemName: 'Enter shipment name',
    pleaseVolume: 'Enter shipment length x width x height',
    pleaseWeight: 'Enter shipment weight',
    drag: 'Drag the file here, or',
    expressName: 'Track delivery name',
    expressNo: 'waybill number'
  },
  customer: {
    feedback: 'Feedback',
    phone: 'Customer service phone',
    email: 'Service mailbox'
  },
  newFeedback: {
    location: 'Current location',
    newWord: 'Add new questions',
    firstname: 'Surname',
    surname: 'First Name',
    telphone: 'Mobile number',
    email: 'Email',
    type: 'Questions Type',
    desc: 'Descriptions',
    dialogImageUrl: 'Attachment',
    submit: 'Continue',
    uploadTips: 'Upload image or pdf file under 2MB,  no more than 9 files.',
    pleaseTelephone: 'Enter phone',
    pleaseType: 'Select type',
    pleaseDesc: 'Enter descriptions'
  },
  shop: {
    favorite: 'Add to List',
    advisory: 'Chat Online',
    videoCall: 'Video Talk',
    category: 'Categories',
    desc: 'About Us ',
    home: 'To Store',
    map: 'Navigation',
    commodity: 'Products',
    detailDesc: 'Detailed introduction',
    recommend: 'Recommend',
    qualification: 'Certificates',
    buyerRating: 'Customer Ratings',
    evaluation: 'Reviews',
    star: 'Star',
    ranking: 'Rank',
    betterThan: 'higher than',
    similarBusinesses1: 'similar stores',
    similarBusinesses2: 'all stores',
    monthlyTurnoverRanking: 'Monthly Sales Rank',
    honor: 'Honors & certifications',
    shopNavigation: 'Map',
    viewShop: 'Learn more',
    phone: 'Phone number',
    date: 'Business hours',
    main: 'Main products',
    dayRanking: 'Transaction amount of the day(rank)',
    dayNumber: 'Number of orders made on the same day(number)',
    market: 'A total of stores in the market',
    typeStar1: 'one star',
    typeStar2: 'two star',
    typeStar3: 'three star',
    typeStar4: 'four star',
    typeStar5: 'five star',
    store: 'Store',
    selectPro: 'Featured Products',
    productAll: 'Categories',
    live: 'Live Stream',
    Scan: 'Scan to view',
    score: 'Score',
    shopmap: 'Map',
    talents: 'Recruitment',
    phyShopIntroduce: 'About Us',
    cancel: 'Cancel'
  },
  commodity: {
    commodityInfo: 'Commodity information',
    attributes: 'Attributes',
    unitPrice: 'Unit Price',
    quantity: 'Qty',
    subtotal: 'Subtotal',
    weight: 'Weight',
    operating: 'Deletion',
    title: 'Please check order information'
  },
  articleList: {
    title: 'Media',
    releasetime: 'Released at'
  },
  antiepidemic: {
    purchaserRegister: 'Buyers Registration Consultation',
    provideRegister: 'Supplier Registration Consultation',
    viewMore: 'View More',
    location: 'Current location',
    epidemicZone: 'Epidemic prevention',
    firstname: 'Surname',
    surename: 'First Name',
    telephone: 'Mobile number',
    country: 'Nationality',
    idcardPic: 'ID card',
    idcardPositive: 'Front',
    idcardOtherSide: 'Back',
    uploadTips: '*Support image file formats like JPG, PNG and BMP, with each no more than 20MB！',
    desc: 'Description',
    submit: 'Submit',
    pleaseName: 'Enter',
    placeTelephone: 'Enter phone',
    placeCountry: 'Select Nationality',
    placeIdcardPic: 'Please upload the front & back of ID card',
    placeDesc: 'Enter Description',
    placeSelect: 'Please Select'
  },
  account: {
    myInfotitle: 'Account',
    username1: 'Name',
    modify: 'Change',
    username: 'Nickname',
    lagonName: 'Name',
    country: 'Nationality',
    intetion: 'Want to buy',
    contractStatus: 'Contract registration status',
    certified: 'Verified',
    notCertified: 'Unverified',
    notSetting: 'Not set',
    notRegister: 'Unregistered',
    applyRegister: 'Apply',
    failRegister: 'Registration failed',
    contactManager: 'Submit My Questions',
    registered: 'Registered',
    isTImed: 'Expire by',
    overTime: 'Expire by xxx',
    againRegister: 'Re-register',
    add: 'Add',
    tips: 'Please complete real-name authentication to experience the contract transaction. ',
    paySurename: "Payer's Surname",
    payFirstname: "Payer's Firstname",
    payAccountNumber: "Payer's account",
    payCountry: "Payer's nationality",
    receiveGoods: "Recipient's email",
    title: 'Account login',
    placeholderUser: 'User Name',
    placeholderPassword: 'Password',
    noLogin: 'No relogin required within 7 days',
    submit: 'Sign in',
    goRegister: 'Get Verification Code',
    invationCode: 'Invitation Code',
    cue1: 'If you are enterprise, please go to',
    cue2: 'Enterprise Real-name Authentication'
  },
  cart: {
    addCart1: 'Add to Cart',
    addCart2: 'Orders',
    addCart3: 'Payment',
    addCart4: 'Completion',
    settlement: 'Proceed to Checkout',
    sign_pay: 'Sign Contract/Checkout',
    totalPrice: 'Total price',
    discount: 'Discounts',
    clearCart: 'Empty cart',
    deleteCommodity: 'Delete the ticked',
    inStock: 'In Stock',
    soldOut: 'Currently unavailable',
    selectAddress: 'Select Address',
    selectShippingMethods: 'Select a delivery method',
    confirmOrder: 'Please check order information',
    freight: 'Include freight charges',
    taxrate: 'Tariff',
    theAmountOfGoods: 'Price',
    merchantOffers: 'Save',
    grossWeight: 'total weight',
    totalPayable: 'Total price',
    backToCart: 'To Cart',
    toCart: 'To Cart',
    submitOrders: 'Continue ',
    recentlyJoined: 'Recently added products',
    shoppingCartTotal: 'in cart',
    pieces: 'items',
    backToHome: 'Homepage',
    checkOrder: 'View Orders ',
    paySuccess: 'Success',
    repay: 'Continue',
    paySuccessMessage: 'You just paid',
    payError: 'Fail',
    payErrorMessage: 'Fail to pay? Please try again.',
    showAddress: 'More',
    hideAddress: 'Hide address',
    payTheBalance: 'Pay Balance',
    toSignUp: 'Next',
    toPayDeposit: 'Make Down Payment',
    deleteOrder: 'Delete order',
    toPay: 'Continue',
    addCart5: 'Confirm contract',
    title: 'Contract Terms',
    pdf: 'Order Contract. pdf ',
    linkType: 'or go to order center to view the signed contract ~',
    canClick: 'Click',
    paySuccess1: 'Success',
    payTips: 'Payment may be delayed, please check order center for details.',
    fare: 'freight charges',
    orderPrice: 'order amount',
    cartEmpty: 'Cart is empty Shopping around',
    shopAround: 'Shopping around'
  },
  sideMenu: {
    learnMore: 'Learn more about activity information',
    code: 'Wechat Account '
  },
  footer: {
    txt1: 'SOE Guarantee',
    txt2: 'Reliable Merchants',
    txt3: 'Low Cost Logistics',
    txt4: 'Easy Export & Import',
    listOne: 'Cooperation Application',
    listOne1: 'Market Merchants',
    listOne2: 'Manufacturers',
    listOne4: 'Exhibitors',
    listOne3: 'Third Party Organization',
    listOne5: 'Professionals',
    listTwo: 'Sellers Center',
    listTwo1: 'Seller Sign-in',
    listTwo2: 'Platform Rules',
    listTwo3: 'Market Services',
    listTwo4: 'Logistics',
    listTwo5: 'Industry Finance',
    listThree: 'Shopping Guide',
    listThree1: 'Create Account',
    listThree2: 'Buying Process',
    listThree3: 'Contract Order',
    listThree4: 'Payment Method',
    listThree5: 'FAQ',
    listFour: 'About Us',
    listFour1: 'Yiwu',
    listFour2: 'Market Overview',
    listFour3: 'Notifications',
    listFour4: 'Global Layout',
    listFour5: 'CCC Group',
    txtContent:
      'CCC Group, which develops and runs chinagoods.com（SH.600415）, is the largest listed state-owned enterprise in Yiwu. It also manages the physical Yiwu markets.',
    txtContent1:
      'All stores on chinagoods.com have booths in Yiwu markets, which means they must meet both online and offline management requirements.Reliability is thus enhanced a lot.',
    txtContent2:
      'As the national logistics hub, Yiwu’s express delivery volume was top 2 only after Guangzhou. Logistics from Yiwu to the world costs much lower. Ultimately, the overall transaction cost is reduced.',
    txtContent3:
      'Yiwu Comprehensive Bonded Zone and years of export-oriented economy enable Yiwu with favorable import & export policy, rich resources and experienced professionals.',
    buyAppDownload: 'Download buyer app',
    hotline: 'Market Hotline',
    onToFive: '8：30—17：00 on Weekdays',
    zheSafe: 'Zhejiang Public Security',
    netWorkTrue: 'Network Culture Business License',
    telecom: 'Appreciation Teleservice Business License',
    zhe: 'Zhe',
    zheWwen: '',
    zheWwenNum: 'No.(2020)1471-068',
    radioTv: 'Radio and Television Programme Production Business Licence',
    zheNum: '(Zhejiang) No. 05037',
    marketName: 'Market Name Registration Certificate',
    indystry: '',
    indystryNum: 'No.3307821094',
    officialLink: 'Follow us',
    attention: 'Wechat Account ',
    commodity: 'Privacy Statement and Protection Policy',
    record: 'Put on record',
    recordZhe: 'Zhe ICP record',
    recordNum: 'No.20008226',
    zheCompany: 'Zhejiang China Commodities City Group Co.',
    recordCopy: '©2020',
    company: 'Yiwu China Commodities City Big Data Co.,ltd',
    copyRight: 'All right reserved',
    userSerect: 'User Service Agreement',
    downloadMore: 'Download other app',
    yiwcompany: '2020 Yiwu China Commodities City Big Data Co., Ltd. All rights reserved.',
    zheChinaCompany:
      'The only official website of Zhejiang China Commodities City Group Co., Ltd.（600415）'
  },
  submitOrder: {
    contractType: 'Transactions',
    noContract: 'Non-contract',
    Contract: 'Contract',
    outsideContract: 'Forex',
    linkType:
      'Real-name authentication required.Go to Individual/ Enterprise Real-name Authentication ',
    linkTypeContract: 'Contract',
    linkTypeForeign: 'Forex',
    linkTypeMessage: 'Real-name authentication required:',
    personCer: 'Go to Individual',
    companyCer: 'Enterprise Real-name Authentication',
    payAccount: 'Select payment account',
    addAccount: 'Add a payment account',
    selectAddress: 'Select a address',
    addAddress: 'Add another address',
    selectLogistics: 'Select a delivery method',
    businessExpress: 'Ship by suppliers',
    mallExpress: 'Ship by chinagoods',
    tips:
      'chinagoods.com coordinates to provide contact person and information of the logistics company.',
    accountList: {
      addaAddress: 'Add a address',
      addAccount: 'Add a forex account',
      name: 'Contact',
      placeholderName: 'Enter contact',
      placeholdTelephone: 'Enter phone number',
      addAddress: 'Add another address',
      placeRecipientName: 'Enter Recipient name',
      changeAddress: 'Change address '
    },
    note: 'Tips'
  },
  message: {
    sure: 'Continue',
    cancle: 'Cancel',
    tips: 'Tips',
    tips1: 'Video error. Cause of error: ',
    tips2: 'Are you sure to delete this item?',
    tips3: 'Success',
    tips4: 'Cancelled',
    tips5: 'Success',
    tips6: 'The uploaded file type must be JPG, JPEG, PNG, GIF or BPM!',
    tips7: 'please upload image under 20MB!',
    tips8: 'Please upload the front of ID card',
    tips9: 'No item is selected',
    tips10: 'This operation will empty the cart ,if to continue?',
    tips11:
      'Multiple stores are not supported for settlement at the same time, please choose again！',
    tips12: 'Canceled collection!',
    tips13: 'Collection success!',
    tips14: 'Currently, it is invited broadcast, which is not open to you',
    tips15: 'Currently, it is invited broadcast, please retry after logging in',
    tips16: 'Deletion is unrecoverable, still delete?',
    tips17: 'Suceess',
    tips18: 'Success',
    tips19: 'Success',
    tips20: 'Success',
    tips21: 'The uploaded file type must be JPG, JPEG, PNG, GIF or PDF!',
    tips22: 'Upload file under 5MB!',
    tips24: 'Please complete real-name authentication',
    tips25: 'Success',
    tips26: 'Success',
    tips27: 'Verification code has been sent',
    tips28: 'Delete order?',
    tips29: 'Success',
    tips30: 'It is not opened temporarily',
    tips31: 'Things that are done will not be replied',
    tips32: 'Upload file under 2MB!',
    tips33: 'The store has no customer service, please wait.',
    tips34: "you're not invited yet.",
    tips35: "You’re in chat room already, please don't re-do!",
    tips36: 'Join succeeded.',
    tips37: 'Your application is successful. Wait for confirmation.',
    tips38: 'This operation will delete the account ,if to continue?',
    tips39: 'Add shipping address',
    tips40: 'Yes',
    tips41: 'No',
    tips42: 'Payment succeeded?',
    tips43: "You're deleting the address, still continue?",
    tips44: 'The contract is in preparation.Thanks for your patience.',
    tips45: 'OK',
    tips46: 'Deletion is unrecoverable, still delete?',
    tips47: 'Create successfully',
    tips48: 'You cannot apply to return the item again if you cancel, still cancel?',
    tips49: 'Empty message is not allowed.',
    tips50: 'Close live stream',
    tips51: 'No unread messages.',
    tips52: 'View all',
    tips53: 'Success',
    tips54: 'The user was not found',
    tips55: 'no more than nine files.',
    tips56: 'Delete failed',
    tips57: 'Please select a forex account!',
    tips58: 'Understock',
    tips61: 'has been sent'
  },
  foreign: {
    title: 'Forex Order Details',
    businessSure: "Wait for the store's confirmation.",
    orderNo: 'Order ID',
    price: 'Amount payable',
    payMethods: 'Payment method',
    type1: 'Instalment 1',
    type2: 'Instalment 2',
    type3: 'Instalment 3',
    confirmInfo: 'Confirm information',
    rmbTotal: 'Total RMB',
    proposeTotal: 'Total Forex '
  },
  identifier: {
    tips: 'Order submitted successfully, please make payment ASAP.',
    readInfo: 'Please read below carefully:',
    type1:
      "1. Please note the  payment method agreed to the order is under the ICBC's (Industrial and Commercial Bank of China) supervision.",
    type2:
      "2. Remember to enter the payment code in remarks, or such payment will fail to be subject to the ICBC's supervision.",
    type3:
      "3. Don't use other payment methods, or the payment will fail to be subject to the ICBC's supervision.",
    type4: '4. Please enter payment codes in sequence matching with each of your actual payment.',
    type5:
      '5. ICBC shall not assume any responsibility for the loss due to your own mistake or error.',
    collectAccountInfo: 'Payee Account Information:',
    payCodeInfo: 'Payment codes',
    tips1:
      "Note：Remember to enter the payment code in remarks, or such payment will fail to be subject to the ICBC's supervision.",
    number: 'Payee Account',
    payCode: 'Payment codes',
    pay: 'Amounts',
    bank: 'Payee’s bank',
    payee: 'Payee',
    payeeAccount: 'Payee’s account',
    payeeAddress: 'Payee’s address',
    contant: 'Contact',
    telephone: 'Telephone'
  },
  chat: {
    cancelBlackout: 'Cancel blacklist',
    tips1: 'Blacklist is still empty',
    noNickname: 'This user has not set a nickname',
    joinBlackList: 'Add this user to the blacklist',
    joinBlack: 'Add to the blacklist',
    removeBlackList: 'Remove the user from the blacklist',
    removeBlack: 'Romove from the blacklist',
    deleteSession: 'Delete conversation',
    systemInfo: 'System notification',
    mentioned: '[@]',
    refreshList: 'Reflesh the list',
    startSession: 'Start a conversation quickly',
    pleaseUserId: "Please enter user's number",
    viewDetail: 'View details',
    noMore: 'No more',
    backLatest: 'Back to the latest position',
    editProfile: 'Edit personal information',
    headPortrait: 'Head portrait',
    nickname: 'Nickname',
    pleaseHeadPro: '头像地址(URL)',
    noDisplay: 'Blank',
    tips2: '头像应该是 Url 地址',
    sessionList: 'Conversation list',
    balckList: 'Blacklist',
    close: 'Off',
    rateAndProposal: 'Ratings and suggestions for IM DEMO',
    custom: 'You may parse custom message on your own',
    clickDownload: 'Click on the download',
    clickDetail: 'Click here for details',
    handle: 'Process',
    handleGroupApp: 'Process add group application',
    processResult: 'Results: ',
    agree: 'Consent',
    refuse: 'Refuse',
    postscript: 'Postscript: ',
    pleasePostscrpt: 'Please enter postscript',
    clickPlay: 'Click on play',
    onPhone: 'There is a phone call',
    onPhoning: 'Calling',
    noCamera: 'Camera is not on',
    cameraPower: 'Make sure the camera and microphone are connected and granted access',
    withdraw: 'Withdraw',
    reEdit: 'Re-edit',
    notSupportMessageType: 'Message types are not currently supported: ',
    expression: 'Send an emoji',
    sendCustomMessage: 'Send custom message',
    rateAndUse: 'Suggestions and usage feeling for IM Web demo',
    suggest: 'Suggest ',
    tips3: 'Press Enter to send the message, Ctrl+Enter for newline',
    notSupportMessage: 'This message is not currently supported',
    welcome: 'Welcome: ',
    joinChat: 'Join the chat room',
    groupMembers: 'Group members: ',
    exitChat: 'Quit',
    kickoutGroup: 'Kick out of the group',
    cover: 'was',
    becomeAdmain: 'Become an administrator',
    revokedAdmain: 'Administrator was revoked',
    changeGroupDetail: 'Group data modification',
    changeMemberDetail: 'Member data modication',
    groupMessage: '[Group hint message]',
    groupSystemMessage: 'Group system notification',
    systemMessage: 'System notification',
    preview: 'preview',
    conversation: 'conversation'
  },
  private: {
    privateGoods: 'Special goods',
    enterProPas: 'Please enter password',
    passwordError: 'Wrong password',
    price: 'Price',
    startBatch: 'MOQ',
    viewPrivateGoods: 'View the goods with invited code',
    pleaseholderPrivate: 'Please enter the invited code'
  },
  bargain: {
    num: '0 thousand',
    yi: 'one hundred million +',
    orders: 'Monthly Orders ',
    dan: '',
    weeks: 'Weeks Orders',
    turnover: 'Orders',
    saleTop: 'Sales'
  },
  zhenmodify: {
    door: 'Door to door',
    port: 'Port to port',
    price: 'Price',
    ratings: 'Ratings',
    sellerrating: 'Seller Rating',
    currentpoint: 'Current point',
    livevideo: 'Live video',
    ALLMarkets: 'All Markets',
    Collection: 'Add to list',
    Navigation: 'Navigation',
    Bulletin: 'Bulletin',
    Replay: 'Replay',
    LiveIntroduction: 'Introduction of Live',
    Nointroduction: 'No introduction',
    Views: 'Views',
    Products: 'Products',
    LiveReplay: 'Replay',
    startquantity: 'Quantity',
    Quantity: 'Quantity',
    Cart: 'Add to Cart',
    Buy: 'Buy Now',
    Liveing: 'Live',
    View: 'View',
    Noscore: 'No score',
    Viewers: 'Viewers',
    points: 'points'
  },
  loginPage: {
    pleasePhoneNumber: 'Mobile number',
    pleasePassword: 'Password',
    pleaseCode: 'Code',
    getCode: 'Send',
    pleaseCodeLogin: 'Verification code sign in',
    pleasePasswordeLogin: 'Password sign in',
    btnText: 'SIGN IN',
    pleaseAccoutLogin: 'Email address',
    pleaseNewPassword: 'Please enter a new password',
    pleaseConfirmNewPassword: 'Please confirm the new password again'
  }
}
